module.exports = __webpack_public_path__ + "media/img/uploads/program-office-us-army-8af426ebd0664e8581535e902dfaf5ee.jpg";